import React, {Component} from "react"
import PropTypes from "prop-types"
import {set} from "lodash"
import {connect} from "@irati/store"

import AuthActions from "@irati/auth/store/actions/AuthActions"
import Loading from "@irati/ui/src/Loading"
import SuccessText from "@irati/ui/src/SuccessText"
import userService from "@irati/identity/services/users"
import Card from "@irati/ui/src/Layout/Card"
import Form from "@irati/ui/src/Form"
import {H1} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"
import ContactPreferences from "../../components/ContactPreferences"

class UpdateContactPreferences extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    updateAuth: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    const load = userService.get(this.props.user.uuid, {}, {fetchPolicy: "network-only"}).then((user) => {
      this.setState({user})
    })
    this.state = {
      load,
      saving: null,
      user: {}
    }
  }

  handleChange = (marketingEmailsAllowed) => {
    const user = {...this.state.user}
    set(user, "marketingEmailsAllowed", marketingEmailsAllowed)
    this.setState({user})
  }

  handleSubmit = () => {
    const {user} = this.state
    const data = {
      uuid: user.uuid,
      marketingEmailsAllowed: user.marketingEmailsAllowed
    }
    const saving = userService.update({user: data}).then((updatedUser) => {
      this.props.updateAuth({user: updatedUser})
      this.setState({user: updatedUser, saved: true})
      setTimeout(() => {
        this.setState({
          saved: false
        })
      }, 3000)
    })
    this.setState({saving})
  }

  render() {
    const {load, saved, saving} = this.state

    return (
      <Card tiny noBorder>
        <H1 marginBottom={4}>
          <FormattedMessage id="account.contact.header" />
        </H1>
        <Loading load={load}>
          <Form>
            <ContactPreferences />
            <Loading load={saving} />
            {saved && (
              <SuccessText>
                <FormattedMessage id="account.contact.updateSuccessful" />
              </SuccessText>
            )}
          </Form>
        </Loading>
      </Card>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateAuth: (user) => {
      dispatch(AuthActions.UpdateAuthAction(user))
    }
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.user
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdateContactPreferences)
